/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react'
import {Html, useGLTF, useTexture} from '@react-three/drei'
import {GLTF} from 'three/examples/jsm/loaders/GLTFLoader'
import {IS_MOBILE, ROOT_PATH_PREFIX} from "../../../common/const";
import {disposeScene} from "../../../../utils/disposeScene";
import {useLoader} from "@react-three/fiber";
import {GLTFLoader} from "three-stdlib";
import {GLTFResult_ObjetModernProducts} from "./Product_Harvester";
import {useObjetColorStore} from "../../../../stores/objetProductStore";
import {useModalTutorial} from "../../../../stores/modalStore";
import {TextureLoader} from "three";
import {air_care_data, Objet_ColorCategoryType} from "../../../../api/products/objetProductsData";
import {LangLabelType} from "../../../../api/lang/langData";
import {easeCubicInOut} from "d3-ease";
import {animated, useSpring} from "@react-spring/web";
import {a} from "@react-spring/three";
import ObjetProductContainer3D from "../../../common/ObjetProductContainer3D";
import ObjetPlusButton from "../../ObjetPlusButton";
import {useKTXLoader} from "../../../../utils/useKTXLoader";
import useHistoryStore from "../../../../stores/historyStore";


const GLTF_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/modern/m/modern_products_ktx2.glb') :
    (ROOT_PATH_PREFIX + '/RP/rooms/modern/modern_products_ktx2.glb');
const LIGHT_MAP_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/Lightmap_Aero360_modern.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/Lightmap_Aero360_modern.jpg');
const COLOR_0_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/aero_360/green_Bake1_pbr_diffuse.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/aero_360/green_Bake1_pbr_diffuse.jpg');
const COLOR_1_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/m/map/aero_360/red_Bake1_pbr_diffuse.jpg') :
    (ROOT_PATH_PREFIX + '/RP/rooms/natural/map/aero_360/red_Bake1_pbr_diffuse.jpg');

export default function Model(props: JSX.IntrinsicElements['group']) {
    const group = useRef<THREE.Group>()
    const {nodes, materials, scene} = useKTXLoader(GLTF_URL) as GLTFResult_ObjetModernProducts
    const lightmapTex = useLoader(TextureLoader, LIGHT_MAP_URL);

    const colorTextures = useTexture([COLOR_0_URL, COLOR_1_URL]);

    const colorCategory = useObjetColorStore(state => state.air_care_ColorCategory);
    const colorLabel = useObjetColorStore(state => state.air_care_ColorLabel);

    const isOpenTutorial = useModalTutorial(state => state.isOpen);

    const [isSet, setIsSet] = useState(false);
    const [spring, animate] = useSpring(() => ({
        from: {
            opacity: 0
        }
    }));

    useLayoutEffect(() => {
        lightmapTex.flipY = false;
        lightmapTex.encoding = THREE.sRGBEncoding;
        lightmapTex.needsUpdate = true;

        materials["mat_body.006"].lightMap = lightmapTex;
        materials["mat_body.006"].lightMapIntensity = 0;
        materials["mat_body.006"].envMapIntensity = 1.8;

        colorTextures[0].flipY = false;
        colorTextures[0].encoding = THREE.sRGBEncoding;
        colorTextures[0].needsUpdate = true;
        materials[`mat_body.006`].map = colorTextures[0];

        changeTexture("mat_body.006", 'Nature', 'objet_color_dark_green', true);

    }, [lightmapTex]);

    useEffect(() => {
        return () => {
            disposeScene(scene);
            lightmapTex.dispose();
            for (let i = 0; i < colorTextures.length; i++) {
                colorTextures[i].dispose();
            }
            useLoader.clear(TextureLoader, LIGHT_MAP_URL);
            useLoader.clear(TextureLoader, [COLOR_0_URL, COLOR_1_URL]);
        }
    }, []);

    const changeTexture = useCallback((materialName: string, colorCategory?: Objet_ColorCategoryType, colorLabel?: LangLabelType, isFirst: boolean = false) => {

        if (colorCategory !== undefined && colorLabel !== undefined && !isFirst) setIsSet(true);

        if (colorCategory === 'Nature') {
            if (colorLabel === 'objet_color_dark_green') {
                colorTextures[0].flipY = false;
                colorTextures[0].encoding = THREE.sRGBEncoding;
                colorTextures[0].needsUpdate = true;
                materials[`${materialName}`].map = colorTextures[0];
            } else if (colorLabel === 'objet_color_redwood') {
                colorTextures[1].flipY = false;
                colorTextures[1].encoding = THREE.sRGBEncoding;
                colorTextures[1].needsUpdate = true;
                materials[`${materialName}`].map = colorTextures[1];
            }
        }
    }, []);

    useLayoutEffect(() => {
        changeTexture('mat_body.006', colorCategory, colorLabel);
    }, [colorCategory, colorLabel]);

    useEffect(() => {
        animate({cancel: true});
        if (!isOpenTutorial) {
            animate({
                cancel: false,
                opacity: !isSet ? 1 : 0,
                delay: 2000,
                config: {duration: 1000, easing: easeCubicInOut},
                // onRest: result => {
                //     console.log(">>>>>", result);
                // }
            });
        }
    }, [isOpenTutorial]);


    const pathname = useHistoryStore(state => state.pathname);

    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                geometry={nodes.aero_360.geometry}
                material={materials['mat_body.006']}
                position={[-2.4565, 0.103, -5.5869]}
                rotation={[0, 1.22, 0]}
            />

            <mesh
                geometry={nodes.aero_360.geometry}
                material={materials['mat_body.006']}
                position={[-2.4565, 0.103, -5.5869]}
                rotation={[0, 1.22, 0]}
                visible={!isSet}
            >
                {/* @ts-ignore */}
                <a.meshBasicMaterial color={"#fff"} depthTest={true} depthWrite={true} transparent={true}
                                     opacity={spring.opacity}/>
                <ObjetPlusButton position={[0, 0.7, 0]} scale={0.8} visible={!(isSet)} opacity={spring.opacity}
                                 color={pathname.indexOf('/air_care') > -1 ? '#be1e42' : '#000'}/>
            </mesh>

            <ObjetProductContainer3D
                args={[0.3, 1.2, 0.3]}
                position={[-2.4565, 0.7, -5.5869]}
                data={air_care_data}
                showDebug={false}
                rotation={[0, 1.22, 0]}
                cameraTargetPos={[0, 0.2, 3]}
            />

        </group>
    )
}
